import React from 'react';
import logo from 'assets/images/login/logo.svg';
import img from 'assets/images/login/img.png';
import laptop from 'assets/images/login/laptop.svg';
import appStore from 'assets/images/login/app-store.svg';
import mobileLogo from 'assets/images/login/mobile-logo.svg';
import play from 'assets/images/login/play.svg';
import { useTranslation } from 'react-i18next';

import styles from './styles.scss';
import { Form } from './Form';

const year = (new Date()).getFullYear();

const Login = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Container}>
        <section className={styles.LeftSide}>
          <div className={styles.LeftSideTitle}>
            <img src={logo} alt="nedvex" />
          </div>
          <div className={styles.LeftSideDescription}>
            <div>
              {t('containers.logIn.description.1')}
            </div>
            <div>
              {t('containers.logIn.description.2')}
            </div>
          </div>
          <div className={styles.LeftSideLaptop}>
            <img src={img} alt="" />
            <img className={styles.LeftSideLaptopImg} src={laptop} alt="" />
          </div>
          <div className={styles.LeftSideStores}>
            <div>
              <a
                target="__blank"
                href="https://apps.apple.com/ru/app/nedvex/id1079767992"
                rel="noopener noreferrer"
              >
                <img src={appStore} alt="app store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=ru.andrroider.apps.nedvex&hl=ru&gl=US"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={play} alt="google play" />
              </a>
            </div>
          </div>
        </section>
        <section className={styles.RightSide}>
          <img className={styles.MobileLogo} src={mobileLogo} />
          <Form />
          <div className={styles.RightSideFooter}>
            <div>
              <span>
                <a
                  target="__blank"
                  href="https://nedvex.ru/privacy"
                >
                  {t('containers.logIn.footer.privacy')}
                </a>
              </span>
              <span>
                {t('containers.logIn.footer.inn')}
              </span>
            </div>
            <div>
              <span>
                {t('containers.logIn.footer.ogrn')}
              </span>
              <span>
                {t('containers.logIn.footer.copyright', {
                  year
                })}
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};


export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login/Login2.js